import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContainerStructureViewModule } from '®shared/container-structure/view';
import { CurrentUserModule } from '®shared/current-user';
import { DashboardAnalyticsModule } from '®shared/dashboard-analytics';
import { EventsModule } from '®shared/events';
import { FocusModule } from '®shared/focus';
import { GoogleAnalyticsGA4Module } from '®shared/google-analytics/google-analytics-ga4';
import { ReportBrokenLinkModalModule } from '®shared/list-item/report-broken-link-modal';
import { ShareSheetModule } from '®shared/list-item/share-sheet';
import { ListItemsModule } from '®shared/list-item/store';
import { ReadingListModule } from '®shared/reading-list/models';
import { OnlineResourceButtonsModule } from '®shared/reading-list/online-resource-buttons';
import { SectionAlertsModule } from '®shared/reading-list/section-alerts/section-alerts.module';
import { SectionListDetailsModule } from '®shared/reading-list/section-list-details/section-list-details.module';
import { TenantModule } from '®shared/tenant';
import { UriModule } from '®shared/url-utils';
import { UserModule } from '®shared/user';
import { UserAnnotationsModule } from '®shared/user-annotations';

import { LtiAlertModule } from '../../lti/lti-alert';

import { SectionResolverModule } from './resolver';
import { sectionViewRouting } from './section-view-routing.module';
import { SectionViewComponent } from './section-view.component';

@NgModule({
  imports: [
    CommonModule,
    ContainerStructureViewModule,
    FocusModule,
    ListItemsModule,
    SectionResolverModule,
    sectionViewRouting,
    CurrentUserModule,
    DashboardAnalyticsModule,
    EventsModule,
    GoogleAnalyticsGA4Module,
    LtiAlertModule,
    OnlineResourceButtonsModule,
    ReadingListModule,
    ReportBrokenLinkModalModule,
    SectionListDetailsModule,
    SectionAlertsModule,
    ShareSheetModule,
    TenantModule,
    UriModule,
    UserAnnotationsModule,
    UserModule,
  ],
  declarations: [SectionViewComponent],
  exports: [SectionViewComponent],
})
export class SectionViewModule {}
